/* eslint-disable import/no-extraneous-dependencies */
import BounceLoader from 'react-spinners/BounceLoader';

const FullPageLoader = () => (
	<div
		className="d-flex justify-content-center align-items-center vw-100 vh-100 position-fixed bg-light bg-gradient bg-opacity-50"
		style={{zIndex: 1, opacity: 0.7}}>
		<BounceLoader
			color="#343a40"
			loading={true}
			size={50}
			aria-label="Loading Spinner"
			data-testid="loader"
		/>
	</div>
);

export default FullPageLoader;
